import React from "react";
import { useSelector } from "react-redux";
import SaveProgressModal from "./SaveProgressModal";

const SaveProgressModalContainer = ({
  isSaveProgressModalOpen,
  setIsSaveProgressModalOpen,
  currentMessage,
  currentPercentage,
}) => {
  const { externalOverlay } = useSelector((state) => state.info);

  return (
    !externalOverlay &&
    isSaveProgressModalOpen && (
      <SaveProgressModal
        currentMessage={currentMessage}
        currentPercentage={currentPercentage}
        onClose={() => setIsSaveProgressModalOpen(false)}
      />
    )
  );
};

export default SaveProgressModalContainer;
